/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const GetOrganizationDashboard = {
  id: 'organization-dashboard.get',
  tag: 'Organization',
  summary: 'Get organization dashboard',
  description: 'Retrieve the organizations projects with their clusters',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/dashboard`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            projects: z.array(
              z.strictObject({
                id: ZodTypes.Id,
                name: z.string().min(1),
                products: z.array(
                  z.strictObject({
                    type: ZodTypes.ServiceType,
                    Creating: z.number().min(0),
                    Updating: z.number().min(0),
                    Importing: z.number().min(0),
                    Running: z.number().min(0),
                    Stopping: z.number().min(0),
                    Starting: z.number().min(0),
                    Stopped: z.number().min(0),
                    Unavailable: z.number().min(0),
                    Error: z.number().min(0),
                  }),
                ),
              }),
            ),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
